import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: '0r1ql2',
    defaultMessage: "We're here to help",
    description: 'Title for the FTU help center component',
  },
  description: {
    id: '00It7U',
    defaultMessage: 'Our experts are ready to guide you every step of the way.',
    description: 'Description text for the FTU help center component',
  },
  callUs: {
    id: 'jY1Tuz',
    defaultMessage: 'Call us',
    description: 'Text for the call support button',
  },
  chatWithUs: {
    id: '0dBwDW',
    defaultMessage: 'Chat with us',
    description: 'Text for the chat support button',
  },
  emailSupport: {
    id: '++3sBp',
    defaultMessage: 'Email support',
    description: 'Text for the email support button',
  },
  phoneIconAlt: {
    id: 'z8QlZN',
    defaultMessage: 'Click to call our help center',
    description: 'Phone icon for FTU help center',
  },
  chatIconAlt: {
    id: 'zSLr9t',
    defaultMessage: 'Chat with the help center',
    description: 'Chat icon for FTU help center',
  },
  emailIconAlt: {
    id: 'yMriDf',
    defaultMessage: 'Email the help center',
    description: 'Email icon for FTU help center',
  },
});

export default messages;
